import { NgModule } from '@angular/core'
import { provideConfig } from '@spartacus/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TRAINING_USP_CONVERTER } from './index'
import { TrainingUspConverter } from './training-usp.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        trainingUspFeature: {
          module: () => import('./training-usp.module').then((m) => m.TrainingUspModule),
          cmsComponents: ['training_usp'],
        },
      }
    }),
    {
      provide: TRAINING_USP_CONVERTER,
      useExisting: TrainingUspConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        training_usp: TRAINING_USP_CONVERTER
      },
      multi: true
    }
  ]
})
export class TrainingUspFeatureModule {
}
